import { GridAggregationFunction } from "@mui/x-data-grid-premium";

/*
 * This is a custom aggregation function that checks if all the child items in the column are true.
 */
const truthyAgg: GridAggregationFunction<unknown, boolean> = {
  apply: (params) => {
    let truthy = true;
    for (let i = 0; i < params.values.length; i += 1) {
      const value = params.values[i];
      if (value !== true) {
        truthy = false;
      }
    }

    return truthy;
  },
  columnTypes: ["boolean"],
};

const sumWithNullsAgg: GridAggregationFunction<unknown, number | null> = {
  apply: ({ values }) => {
    let sum: number | null = null;
    for (let i = 0; i < values.length; i += 1) {
      const value = values[i];
      if (typeof value === 'number' && !Number.isNaN(value)) {
        sum = value + (sum || 0);
      }
    }


    return sum;
  },
  columnTypes: ['number'],
};

export { truthyAgg, sumWithNullsAgg };
